module.exports = __webpack_public_path__ + "static/media/deskneed_back_person.f1e1ae85.jpg";